<style lang="scss" scoped>
  .rectangle-40 {
    height: 32px;
    width: fit-content;
    padding: 8px;
    background: #E8FFF7;
    border-radius: 8px !important;

    &:hover {
      background-color: #E8FFF7;
      #activities-modal {
        display: block;
      }
    }

    &.danger {
      background-color: #FBECEA80;
      &:hover {
        background-color: #FBECEA;
        border-color: #FF2E56;
      }
    }

    &.warning {
      background-color: #F9F7DC66;
      &:hover {
        background-color: #FFFAD6;
        border-color: #FFFAD6;
      }
    }
  }

  #wrapper {
    max-width: 40px;
    height: 20px;
    &:hover {
      > span {
        color: #27C378;
      }
    }
    &.danger {
      background-color: #ffffff80;
      &:hover {
        background-color: #FBECEA;
        border-color: #FF2E56;
      }
    }

    &.warning {
      background-color: #F9F7DC66;
      &:hover {
        background-color: #FFFAD6;
        border-color: #FFFAD6;
      }
    }
    > span {
      padding: 0;
      cursor: pointer;
      color: #06B446;
      font-weight: 600;
      border: none;
      font-size: 14px;
      letter-spacing: -0.17px;
      line-height: 21px;
      &.danger {
        color: #FF2E56;
      }
      &.warning {
        color: #F6B433;
      }
      &:hover {
        & + #activities-modal {
          display: block;
        }
      }
    }
    &:hover #activities-modal,
      #activities-modal:hover {
        display: block;
    }
  }

  #activities-modal:hover {
        display: block;
    }

  #activities-modal {
    z-index: 99;
    width: 290px;
    display: none;
    padding: 8px 30px 24px 30px;
    cursor: initial;
    position: absolute;
    margin: 6px 0 20px;
    box-shadow: 0 10px 20px rgba(103, 70, 162, 0.18);
    border-radius: 12px;
    background-color: #ffffff;

    &.right {
      right: 12px;
      transform: translateX(-10%);
      // left: -140px;

      .triangule {
        text-align: right;
        padding-right: 3px;
      }
    }

    // &.left {
    //   transform: translateX(-75%);
    // }

    &.onBottom {
      //bottom: 15px;
      transform: translateY(-111%);
    }

    .activies-modal__activities {
      overflow: auto;
      max-height: 200px;
    }
  }

  .header {
    color: #242424;
    font-size: 0.875rem;
    font-weight: 700;
    letter-spacing: -0.2px;
    line-height: 21px;
    padding: 15px;
    padding-bottom: 0px;
    margin-bottom: 32px;

    div {
      color: #71767D;
      font-size: 0.625rem;
      font-weight: 600;
      line-height: 15px;
      letter-spacing: -0.14px;
      text-transform: uppercase;
      float: right;
      gap: 3px;

      .active {
        color: #8869FD;
        font-weight: 800;
      }
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 0.6875rem;
    font-weight: 400;
    letter-spacing: -0.17px;
    color: #3b334a;

    .user {
      color: #b2a8c1;
    }

    p {
      margin: 0;

      span {
        opacity: .8;
        font-size: 11px;
      }
    }
  }

  li {
    display: flex;
    padding: 10px 15px;
    align-items: center;
    // border-bottom: 1px solid rgba(204, 204, 204, 0.3);

    &.completed {
      p {
        text-decoration: line-through;
      }

      #activity-content {
        color: #AAAAAB !important;
        font-size: 12px !important;
        line-height: 18px !important;
        font-weight: 400 !important;
      }

      #date-author-container p {
        color: #64748B !important;
      }

      label {
        background-color: #8869FD !important;
        color: white !important;

        svg {
          opacity: 1 !important;
        }
      }
    }
  }

  li:last-child {
    border-bottom: 0px;
  }

  .icon {
    width: 30px;
    height: 30px;
    display: flex;
    margin-right: 10px;
    justify-content: center;

    i.fa {
      font-size: 17px;
    }
  }

  .checkbox {
    margin-left: auto;

    input {
      display: none;
    }

    label {
      width: 20px;
      height: 20px;
      display: flex;
      cursor: pointer;
      font-size: 0.625rem;
      color: #8869FD;
      border-radius: 3px;
      align-items: center;
      justify-content: center;
      border: 1px solid #676E7629;
      border-radius: 50%;
      box-shadow: 0 2px 5px 0 #676E7629;

      svg {
        opacity: 0;
        transition: 150ms;
      }

      &:hover {
        svg {
          opacity: .3;
        }
      }
    }
  }

  .bottom {
    text-align: center;
    height: 55px;
    padding: 15px 0px;

    span {
      color: #130f19;
      cursor: pointer;
      transition: 150ms;
      border-radius: 50%;
      margin: 0px;
      width: 31px;
      height: 31px;
      box-shadow: 0 5px 20px rgba(165, 131, 224, 0.18);
      background-color: #2ceba9;
      opacity: 0.9;
      padding: 10px 12px;

      &:hover {
        opacity: 1;
      }
    }
  }

  .fs-7 {
    font-size: 0.875rem !important;
  }

  .fs-8 {
    font-size: 0.750rem !important;
  }

  .fs-9 {
    font-size: 0.625rem;
  }

  .fw-normal {
    font-weight: 400;
  }

  .fw-semibold {
    font-weight: 600;
  }

  .lh-18 {
    line-height: 18px;
  }

  .lh-15 {
    line-height: 15px;
  }

  .text-dark {
    color: #242424 !important;
  }

  .text-purple {
    color: #8869FD !important;
  }

  .text-grey {
    color: #71767D !important;
  }

  .text-success {
    color: #5AB78D !important;
  } 

  .text-danger {
    color: #FF2E56 !important;
  }

  .bg-purple {
    background-color: #8869FD  !important;
  }
  
  #deal-card-activity-trigger:hover {
    #activities-modal {
      display: block;
    }
  }

  .border-gray {
    border: 1px solid #d1d1d1;
  }

  .border-light-gray {
    border-color: #f5f5f5 !important;
  }

  .left-5 {
    left: 5px;
  }

  .gap-1 {
    gap: 4px;
  }

  .gap-2 {
    gap: 8px;
  }

  .gap-3 {
    gap: 16px;
  }

  .px-3-2 {
    padding-left: 18px;
    padding-right: 18px;
  }

  .px-4-5 {
    padding-left: 30px;
    padding-right: 30px;
  }

  .cursor-default {
    cursor: default !important;
  }

  ::v-deep .tooltip-inner {
    padding: 8px 12px !important;
    border-radius: 8px !important;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    background-color: #000000;
    color: #FFFFFF;
  }

  ::v-deep .arrow::before {
    border-bottom-color: #000000 !important;
  }
</style>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center rectangle-40" :class="badge.class" v-if="deal.status !== 'lost'">
    <div
      id="wrapper"
      class="text-center"
    >
      <span
        @mouseenter="key++"
        :ref="`count-${deal.hashid}`"
        :class="['badge', badge.class]"
        v-b-tooltip="last.format('LD')"
        @click.prevent="openModal(deal)"
      >
        <ExclamationTriangleOutline v-if="badge.class === 'warning'" />
        {{ badge.text }}
      </span>
      <div
        id="activities-modal"
        :key="key"
        @click.stop=""
        :ref="`card-${deal.hashid}`"
        class="p-0 border-gray"
        :class="{ [placement]: true, 'onBottom': onBottom }"
        @mouseenter="showModal = true"
        @mouseleave="showModal = false"
      >
        <div class="header d-flex justify-content-between align-items-center mb-4 px-3-2" v-if="filtered.length || activities.length">
          <span>
            {{ __('Agendamentos') }}
          </span>
          <div @click.prevent.stop="toggleFilter">
            <span :class="{ active: openedOnly }">{{ __('ABERTOS') }}</span><span class="separator"> |</span>
            <span :class="{ active: ! openedOnly }">{{ __('TODOS') }}</span>
          </div>
        </div>
        <div id="padding-wrapper" class="w-100 px-4-5">
          <div class="body">
            <ul
              class="activies-modal__activities"
              v-if="filtered.length"
            >
              <li
                v-for="(activity, key) in filtered"
                :class="{ completed: !! activity.completed_at }"
                class="d-flex align-items-start py-2 px-0 gap-3"
                :key="key"
              >
                <div class="checkbox m-0">
                  <label @click.prevent.stop="emitFinishModal(activity)" :class="{'cursor-default': activity.completed_at}">
                    <input
                      type="checkbox"
                      :checked="!! activity.completed_at"
                    >
                    <IconCheck color="white" />
                    <!-- <i class="fa fa-check" /> -->
                  </label>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-start gap-1">
                  <div class="icon d-flex justify-content-center align-items-center gap-1 w-auto h-auto">
                    <i :class="activity.type.icon" class="fs-7 text-purple" />
                    <span class="fs-9 fw-semibold lh-15 text-purple">
                      {{ activity.type.name }}
                    </span>
                  </div>
                  <p v-if="activity.content || activity.summary" id="activity-content" class="fs-8 fw-normal lh-18 text-dark text-left">
                    {{ parseHtmlString(activity.content || activity.summary) | truncate('60') }}
                  </p>
                  <div id="date-author-container" class="d-flex justify-content-center align-items-start gap-2">
                    <span :class="[ isDelayed(activity.scheduled_at) ? 'text-danger' : activity.completed_at ? 'text-grey' : 'text-success']" class="fs-9 fw-semibold lh-15">
                      {{ activity.scheduled_at | datetime('LD') }} às {{ activity.scheduled_at | datetime('HH:mm') }}
                    </span>
                    <span
                      class="user fs-9 fw-semibold lh-15 text-dark"
                      v-if="activity.user"
                    >
                      {{ __(activity.user.first_name) | truncate('20') }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
            <ul v-else>
              <li class="p-0">
                <div class="d-flex flex-column justify-content-center align-items-center gap-1 pt-4 mx-auto">
                  <p class="fs-8 fw-semibold lh-18 text-dark text-center">{{ __('Lead sem agendamentos') }}!</p>
                  <p class="fs-9 fw-medium lh-15 text-dark text-center">{{ __('Clique no botão abaixo para agendar.') }}</p>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="filtered.length" id="deal-card-border" class="border-bottom w-100 border-light-gray my-1-5"/>
          <div id="bottom" class="mt-3 mb-4">
            <span
              @click.prevent="openModal(deal)"
              v-b-tooltip.right="__('Criar agendamento')"
            >
              <IconRoundCircleWithPlusSignFilled />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';
import ExclamationTriangleOutline from '../icon/ExclamationTriangleOutline.vue';
import IconRoundCircleWithPlusSignFilled from '../icon/RoundCircleWithPlusSignFilled.vue';
import IconCheck from '../icon/Check.vue';

const sortActivities = (activities) => activities
  .filter((activity) => {
    return activity.scheduled_at != null;
  })
  .sort((a, b) => dayjs(b.scheduled_at).diff(a.scheduled_at));

export default {
  components: {
    ExclamationTriangleOutline,
    IconRoundCircleWithPlusSignFilled,
    IconCheck,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['deal', 'lead', 'placement', 'openModal'],

  data () {
    return {
      showModal: false,
      key: 0,
      activities: sortActivities(this.lead.activities),
      openedOnly: true,
    };
  },

  created () {
    Bus.$on(`lead.${this.lead.hashid}.activity`, (activity) => this.add(activity));
    
  },
  
  computed: {
    badge () {
      if (this.activities.length === 0) {
        return {
          class: 'warning',
          text: '',
        };
      }

      const diff = dayjs.duration(this.last.diff(Date.now()));

      return {
        class: diff.$ms <= 0 ? 'danger' : '',
        text: this.badgeText(),
      };
    },

    last () {
      if (this.opened.length != 0) {
        return dayjs(this.opened[0].scheduled_at);
      }

      // if (this.activities.length != 0) {
      //   return dayjs(this.activities[0].created_at);
      // }

      return dayjs(this.deal.created_at);
    },

    opened () {
      return this.activities.filter(({ completed_at }) => completed_at == null);
    },

    filtered () {
      const activities = this.openedOnly ? this.opened : this.activities;

      return activities.filter(({ hide }) => ! hide);
    },

    onBottom () {
      if (this.key > 0) {
        /**
           * Get height of modal
           */
        const {
          offsetHeight = 0,
        } = this.$refs[`card-${this.deal.hashid}`] || {};

        /**
           * Get position of count of the days
           */
        const {
          top,
        } = (this.$refs[`count-${this.deal.hashid}`] || {}).getBoundingClientRect();

        /**
           * Get height of viewport
           */
        const viewHeight = document.documentElement.clientHeight;

        /**
           * Verifiy if count has on bottom
           */
        return (viewHeight - top) < offsetHeight;
      }

      return false;
    },
  },

  methods: {
    emitFinishModal(activity) {
      if (!activity.completed_at) {
        Bus.$emit('openFinishActivityModalBoard', {
          activity,
          cardHash: this.deal.lead.hashid
        });
      }
    },
    parseHtmlString (htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      return doc.body.textContent || '';
    },

    markAsCompleted (activity) {
      if (! activity.completed_at) {
        activity.completed_at = new Date();
      } else {
        activity.completed_at = null;
      }

      this.$http.put(`/lead/${this.lead.hashid}/activity/${activity.id}`, {
        complete: !! activity.completed_at,
      }).catch(() => Alert.error(this.__('Erro ao atualizar atividades')));
    },

    toggleFilter () {
      this.openedOnly = ! this.openedOnly;
    },

    add (activity) {
      if (activity.scheduled_at == null) {
        return;
      }

      this.activities.push(activity);
      this.activities = sortActivities(this.activities);
    },

    badgeText () {
      const now = dayjs();

      const days = Math.abs(now.diff(this.last, 'day'));

      if (days >= 1) {
        return `${days}d`;
      }

      const hours = Math.abs(now.diff(this.last, 'hour'));

      if (hours >= 0) {
        return `${hours}h`;
      }

      const minutes = Math.abs(now.diff(this.last, 'minute'));

      return `${minutes}m`;
    },

    isDelayed (date) {
      const today = new Date();

      return date && today.getTime() > new Date(date).getTime();
    },
  },
};
</script>
